module.exports = __webpack_public_path__ + "static/customize_2-541ddf62c666f7a31e0d2e026ebed854.png";